require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-glennsl-bs-refmt.json") })
        }
      }, "path---package-unpublished-glennsl-bs-refmt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-glennsl-bs-refmt!./.cache/json/package-unpublished-glennsl-bs-refmt.json
// module id = 940
// module chunks = 231608221292675